import React from "react"
import { StyleBodyContainer } from "./StyleBodyContainer"

export const Bodycontainer = () => {

    return(
        <StyleBodyContainer />
       
    )
}